import { createSlice } from "@reduxjs/toolkit";
import appConst from '../Utilities/appConst.json';
import stepper from '../Utilities/stepperUtil'


const initialState = {
    guardIndex: window.location.pathname === appConst.NINTH_PAGE && (sessionStorage.getItem(appConst.ORDERTOKEN) != null) ? stepper.get(appConst.NINTH_PAGE) : -1,
};
const guardSlice = createSlice({
    name: 'guard',
    initialState,
    reducers: {
        setGuardIndex: (state, action) => {
            if (action.payload < state.guardIndex + 2) {
                state.guardIndex = action.payload;
            }
        },

    }
});


export const guardActions = guardSlice.actions;
export default guardSlice;